module.exports = __webpack_public_path__ + "static/img/shibai.dbb8dc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market103/shibai.png
// module id = YyXZ
// module chunks = 1